// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login {
    height: 100vh;
    width: 100vw;
    background-color: #252525;
    ;
}
.codexLogo{
    font-size: 30px;
    /* color: var(--color1Ink); */
    color: var(--color1Achemed);
}
.login .card-header,
.login .card-body {
    background-color: #000000;
}
.login .card-header{
    border-radius: 10px 10px 0px 0px;
    display: flex;
    align-items: center;
}
.login .card-body {
    border-radius: 0px 0px 10px 10px;
}
.login .card {
    border-radius: 20px;
}
.login label {
    color: white;
}

.imgLogo {
    height: 60px;
    margin: 13px;
    margin-bottom: 16px;
}

.card-header {
    text-align: center;
}

.btn-login {
    padding: 8px 24px !important;
    background-color: var(--color1Achemed);
    border-color: var(--color1Achemed);
    font-weight: 400;
    font-size: 16px;
    border-radius: 12px;
}
.btn-login:hover{
    background-color: var(--color2Ink);

}

.inputLogin {
    background: black;
    color: white;
}

.inputLogin:focus {
    background-color: black;
    color: white;
}

footer.bg-light {
    background-color: #000000 !important;
}

footer .text-muted {
    color: white !important;
}
.error-msg{
    color: #ff3333;
    font-size: 12px;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}`, "",{"version":3,"sources":["webpack://./src/views/login/Login.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,YAAY;IACZ,yBAAyB;;AAE7B;AACA;IACI,eAAe;IACf,6BAA6B;IAC7B,2BAA2B;AAC/B;AACA;;IAEI,yBAAyB;AAC7B;AACA;IACI,gCAAgC;IAChC,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,gCAAgC;AACpC;AACA;IACI,mBAAmB;AACvB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,sCAAsC;IACtC,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,kCAAkC;;AAEtC;;AAEA;IACI,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,uBAAuB;AAC3B;AACA;IACI,cAAc;IACd,eAAe;IACf,mJAAmJ;AACvJ","sourcesContent":[".login {\n    height: 100vh;\n    width: 100vw;\n    background-color: #252525;\n    ;\n}\n.codexLogo{\n    font-size: 30px;\n    /* color: var(--color1Ink); */\n    color: var(--color1Achemed);\n}\n.login .card-header,\n.login .card-body {\n    background-color: #000000;\n}\n.login .card-header{\n    border-radius: 10px 10px 0px 0px;\n    display: flex;\n    align-items: center;\n}\n.login .card-body {\n    border-radius: 0px 0px 10px 10px;\n}\n.login .card {\n    border-radius: 20px;\n}\n.login label {\n    color: white;\n}\n\n.imgLogo {\n    height: 60px;\n    margin: 13px;\n    margin-bottom: 16px;\n}\n\n.card-header {\n    text-align: center;\n}\n\n.btn-login {\n    padding: 8px 24px !important;\n    background-color: var(--color1Achemed);\n    border-color: var(--color1Achemed);\n    font-weight: 400;\n    font-size: 16px;\n    border-radius: 12px;\n}\n.btn-login:hover{\n    background-color: var(--color2Ink);\n\n}\n\n.inputLogin {\n    background: black;\n    color: white;\n}\n\n.inputLogin:focus {\n    background-color: black;\n    color: white;\n}\n\nfooter.bg-light {\n    background-color: #000000 !important;\n}\n\nfooter .text-muted {\n    color: white !important;\n}\n.error-msg{\n    color: #ff3333;\n    font-size: 12px;\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
